import { useSymbolsStore } from "../store/Symbols.js";
import { useSymbolsRender } from "../utils/useRender.js";
export var Colon = props => {
  var {
    Colon: Comp = {}
  } = useSymbolsStore();
  useSymbolsRender(Comp, props, 'Colon');
  return null;
};
Colon.displayName = 'JVR.Colon';